import { render, staticRenderFns } from "./ExpensePhoto.vue?vue&type=template&id=2727d979&scoped=true"
import script from "./ExpensePhoto.vue?vue&type=script&lang=ts"
export * from "./ExpensePhoto.vue?vue&type=script&lang=ts"
import style0 from "./ExpensePhoto.vue?vue&type=style&index=0&id=2727d979&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2727d979",
  null
  
)

export default component.exports